export function Skeleton({
	className = '',
	style
}: {
	className?: string;
	style?: React.CSSProperties;
}) {
	return (
		<div
			className={`animate-pulse rounded-lg bg-neutral-800/50 ${className}`}
			style={style}
		/>
	);
}
